import type { OfferResource } from '../generated/metapic-api/metapicApi.schemas'

import { type CampaignTypeEnum } from './campaign.types'
import type {
  Filter,
  Money,
  MoneyServer,
  ProcessableImage,
  ProcessableServerImage,
} from './common.types'
import type { CamelCased } from './requests.types'
import type { SharedBudget, SharedBudgetServer } from './shared-budget.types'
import type { TrafficSourceCosts, TrafficSourceCostServer } from './traffic-source-costs.types'

export enum CampaignStatusEnum {
  Ended = 'ended',
  Scheduled = 'scheduled',
  Paused = 'paused',
  Active = 'active',
}

export type Campaign = CamelCased<OfferResource>

export type CampaignListItemServer = {
  id: number
  type: CampaignTypeEnum
  status: CampaignStatusEnum
  created_at: string
  updated_at: string
  constraints: {
    current_clicks?: number
    current_money?: number
    max_clicks?: number
    max_money?: number
    per_user_limit?: boolean
    valid_from?: string
    valid_until?: string
  }
  has_product_seeding: boolean
  image_url: string
  image?: ProcessableServerImage
  name: string
  offer_campaign_title: string
  offer_campaign_test: string
  priority: number
  show_for_advertiser: boolean
  traffic_sources_costs?: TrafficSourceCostServer[]
  store_id: number
  store_logo: ProcessableServerImage
  store_name: string
  currency: string
  consumed_budget?: {
    amount: number
    currency: string
  }
  shared_budget?: SharedBudgetServer
  budget_limit?: number
  budget_limit_v2?: MoneyServer
  targets?: {
    user_ids: number[]
    store_group_ids: number[]
    user_tag_ids: number[]
    client_ids: number[]
    revenue_tier_ids: number[]
    emails: string[]
    social_media_identifiers: string[]
  }
  campaign_title?: string
  token?: string
}

export type CampaignListItem = {
  id: number
  type: CampaignTypeEnum
  status: CampaignStatusEnum
  internalName: string
  trafficSourceCosts?: TrafficSourceCosts[]
  advertiserLogo?: ProcessableImage
  advertiserId: number
  advertiserName: string
  advertiserCurrency: string
  currentClicks?: number
  maxClicks?: number
  currentMoney?: number
  maxMoney?: number
  validFrom?: string
  validUntil?: string
  createdAt?: string
  image?: ProcessableImage
  perUserLimit: boolean
  budgetLimit?: Money
  consumedBudget?: Money
  sharedBudget?: SharedBudget
  targets?: {
    users: number[]
    storeGroups: number[]
    userTags: number[]
    clients: number[]
    revenueTiers: number[]
    emails: string[]
    socialMediaIdentifiers: string[]
  }
  name?: string
  token?: string
  hashtags?: string[]
}

export type CampaignsFilter = {
  statuses?: CampaignStatusEnum[]
  customSortBy?: string
  format?: 'xlsx' | 'csv'
  targetUserId?: number
  createdBefore?: string
} & Filter

export type CampaignPerformance = {
  labels: string[]
}
